if (!customElements.get('byd-header-menu')) {
  customElements.define(
    'byd-header-menu',
    class BydHeaderMenu extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('.byd-header-menu');
        this.trigger = this.querySelector('.byd-header-nav__trigger');
        this.panel = this.querySelector('.byd-header-menu__panel');
        this.header = document.querySelector('.header-wrapper');
        this.closeTimer = null;
        this.leaveDelay = 150;
        this.onEnter = this.onHoverEnter.bind(this);
        this.onLeave = this.scheduleClose.bind(this);
        this.onTriggerClick = this.onClick.bind(this);
        this.onKey = this.onKeydown.bind(this);
        this.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('pointerleave', this.onLeave);
        this.addEventListener('focusin', this.onEnter);
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.trigger?.addEventListener('click', this.onTriggerClick);
        this.addEventListener('keydown', this.onKey);
      }

      get isTouchDesktop() {
        return window.matchMedia('(hover: none) and (min-width: 990px)').matches;
      }

      onHoverEnter() {
        if (this.isTouchDesktop) return;
        this.open();
      }

      open() {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        clearTimeout(this.closeTimer);
        document.querySelectorAll('byd-header-menu').forEach((el) => {
          if (el !== this) el.close();
        });
        this.panel?.removeAttribute('hidden');
        this.root?.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        if (this.header) this.header.preventHide = true;
      }

      scheduleClose() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(), this.leaveDelay);
      }

      close() {
        clearTimeout(this.closeTimer);
        this.panel?.setAttribute('hidden', '');
        this.root?.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (this.header) this.header.preventHide = false;
      }

      onClick(event) {
        if (!this.isTouchDesktop) return;
        if (!this.root?.classList.contains('is-open')) {
          event.preventDefault();
          this.open();
        }
      }

      onFocusOut() {
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.trigger?.focus();
        }
      }
    }
  );
}

if (!customElements.get('byd-mega-rich')) {
  customElements.define(
    'byd-mega-rich',
    class BydMegaRich extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-mega-rich-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-mega-rich-panel]'));
        if (this.tabs.length === 0) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.megaRichTab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      activate(key) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.megaRichTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.megaRichPanel === key);
        });
      }

      onKeydown(event) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
        const last = this.tabs.length - 1;
        let next = current;
        if (event.key === 'ArrowLeft') next = current <= 0 ? last : current - 1;
        if (event.key === 'ArrowRight') next = current >= last ? 0 : current + 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        const target = this.tabs[next];
        if (!target) return;
        this.activate(target.dataset.megaRichTab);
        target.focus();
      }
    }
  );
}

function setBydRichDrillOpen(open) {
  document.getElementById('menu-drawer')?.classList.toggle('byd-mega-rich-drill-open', open);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-mega-rich-open]');
  if (opener) {
    const panel = document.getElementById(`BydMenu-RichMb-${opener.dataset.megaRichOpen}`);
    if (!panel) return;
    panel.hidden = false;
    setBydRichDrillOpen(true);
    requestAnimationFrame(() => panel.classList.add('is-open'));
    opener.setAttribute('aria-expanded', 'true');
    return;
  }

  const closer = event.target.closest('[data-mega-rich-close]');
  if (!closer) return;
  const panel = closer.closest('[data-mega-rich-panel-mb]');
  if (!panel) return;
  panel.classList.remove('is-open');
  setBydRichDrillOpen(false);
  const id = panel.id.replace('BydMenu-RichMb-', '');
  document.querySelector(`[data-mega-rich-open="${id}"]`)?.setAttribute('aria-expanded', 'false');
  setTimeout(() => {
    panel.hidden = true;
  }, 300);
});

document.addEventListener('click', (event) => {
  const summary = event.target.closest('#Details-menu-drawer-container > summary');
  if (!summary) return;
  const details = summary.parentElement;
  if (details?.hasAttribute('open')) {
    document.querySelectorAll('[data-mega-rich-panel-mb]').forEach((panel) => {
      panel.classList.remove('is-open');
      panel.hidden = true;
    });
    setBydRichDrillOpen(false);
  }
});
